import axios from 'axios';

export default class CropImageService {

    static createCropImage(formData: FormData) {
        return new Promise((resolve, reject) => {
        axios
            .post('/crops',
                formData,
                { headers: {'Content-Type': 'multipart/form-data' }})
            .then((res) => {
                resolve(res.data);
            })
            .catch(error => reject(error));
        });
    }

    static deleteCropImage(cropID: number) {
        return new Promise((resolve, reject) => {
            axios
            .delete(`/crops/${cropID}`)
            .then((_) => {
                resolve(cropID);
            })
            .catch(error => reject(error));
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/CropImageService.ts